export function getClassName<style>(
  options: { style?: style; },
  className: keyof style,
  notset: string = ""
): string {
  return String(options && options.style && options.style[className] ? options.style[className] : notset);
}

export function getClassNameModern<style>(
  options: style | undefined,
  className: keyof style,
  notset: string = ""
): string {
  return String(options && options[className] ? options[className] : notset);
}
